import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { Media } from '@df/ui/display/media/interfaces';
import { MEDIA_OPTIONS } from '@df/ui/display/media/media-options';
import { DeepPartial } from '@df/util/type/deep-partial';
import defaultsDeep from 'lodash-es/defaultsDeep';

export const providers = (config?: DeepPartial<Media.IConfig>) => [
    {
        provide: MEDIA_OPTIONS,
        useFactory: () => {
            return defaultsDeep(config);
        }
    }
];

export function provideDfUiMedia(config?: DeepPartial<Media.IConfig>): EnvironmentProviders {
    return makeEnvironmentProviders(providers(config));
}
